import BaseComponent from "@js/components/base_component.jsx";

// A read-only "Linked Configuration" row for the Sending Domain and Shared
// Tracking Domain view pages. It links to the Incoming Email Domain and URL
// Domain records that are provisioned automatically once DNS is verified, so
// the links only appear once those records exist.
class EuiLinkedConfigurationRow extends BaseComponent {

  render() {
    const incomingEmailDomainId = this.props.incoming_email_domain_id;
    const urlDomainId = this.props.url_domain_id;

    const incomingEmailDomainLink = incomingEmailDomainId ? (
      <a href={ Routes.eui_incoming_email_domain_path({ id: incomingEmailDomainId }) }>
        { I18n.t("labels.incoming_email_domain") }
      </a>
    ) : null;

    const urlDomainLink = urlDomainId ? (
      <a href={ Routes.eui_url_domain_path({ id: urlDomainId }) }>
        { I18n.t("labels.url_domain") }
      </a>
    ) : null;

    if (!incomingEmailDomainLink && !urlDomainLink) return null;

    return (
      <FieldContainer labelText={ I18n.t("labels.linked_configuration") }>
        { incomingEmailDomainLink }
        { incomingEmailDomainLink && urlDomainLink ? ", " : "" }
        { urlDomainLink }
      </FieldContainer>
    );
  }

}

export default EuiLinkedConfigurationRow;
